<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">

  		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Edit Contact Group" :menuAccess="true" :closePage="true"></page-nav-bar>

  		<div class="layoutTop"/>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="panel21 panel-default">

                <div class="panel-heading">
                    <h4 class="content-block labelAccordionForm">
                        <i class="fa fa-address-book formIcon"></i>
                        Edit Contact Group
                    </h4>
                </div>

                <form>
                  <div class="form-group row">
                    <label class="col-5 col-sm-2 col-form-label">Group name</label>
                    <div class="col-7 col-sm-10">
                      <input class="form-control" type="text" placeholder="Group name" v-model="groupName"></input>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-5 col-sm-2 col-form-label">My contacts</label>
                    <div class="col-7 offset-sm-7 col-sm-3">
                      <a href="/account/addContactGroupContactList/">
                        <span href="#" class="button button-round button-inner-color">{{ this.selected.length }} selected</span>
                      </a>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12" v-if="Object.keys(this.selectedDebtors).length > 0">Contacts in this group</div>
                  </div>
                  <div class="form-group row">
                    <div class="col-md-12">
                      <ul class="list-group" v-if="Object.keys(this.selectedDebtors).length !== 0">
                        <li class="list-group-item" v-for="value in this.selectedDebtors" v-bind:key="value.id">{{value.label}}</li>
                      </ul>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 offset-md-9">
              <button
                round
                class="button-action firstButtonMarginTop"
                title="Modify"
                @click="changeContactGroup">
                <i class="icon fa fa-save"></i>
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>


      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      contacts: [],
      contactsObject: {},
      contactSelectionList: [],
      selectedDebtors: {},
      selected: [],
      contactGroupId: '',
      groupName: ''
    }
  },
  created () {
    let that = this
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()

    this.contactGroupId = this.$settings.currentContactGroup.id
    this.groupName = this.$settings.currentContactGroup.label
    this.selected = this.$settings.currentContactGroup.contacts
    this.changeItem()

    that.$engine.settings.set({addContactGroupContactSelected: this.selected})

    this.$bus.$on('refresh-add-contact-group-contact-selected', (data) => {
      that.selected = data
      that.changeItem()
    })
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  methods: {
    changeItem () {
      this.selectedDebtors = {}
      for (var i = 0; i < this.selected.length; i++) {
        this.selectedDebtors[this.selected[i]] = this.contactsObject[this.selected[i]]
      }
    },
    setContacts: function () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id, typeContact: this.$engine.contacts.get(j).typeContact})
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })

      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }

      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeContactGroup () {
      let that = this
      if (that.groupName !== '' && that.selected.length > 0) {
        this.$engine.contacts.updateGroup({
          idContactGroup: this.contactGroupId,
          label: this.groupName,
          contacts: this.selected
        })
        .then(() => {
          that.$f7.modal({
            title: 'Contact modified',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.contactGroupId = ''
            that.groupName = ''
            that.selected = []
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
        this.$f7.closeModal()
      } else {
        this.$f7.alert('', 'Data empty')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMEditContactGroup.vue?dc7c78d4